export enum TipoCuentaBancaria {
  CuentaCorriente = 1,
  CajaAhorro = 2,
}

export enum CondicionFinanciera {
  Activa = 0,
  InactivaTotal = 1,
  InactivaParaPagos = 2,
}

export enum BeneficiaryAccountTypes {
  external = "External",
  internal = "Internal",
}

export enum BeneficiaryAccountTypesLabel {
  external = "Externa",
  internal = "Interna",
}

export enum TransferTransactionTypeEnum {
  AUTO = "Automatica",
  MANUAL = "Manual",
}

export enum RequestTypes {
  Efectivo = 1,
  Cheque = 2,
  ECheq = 3,
  Transferencia = 4,
  TransferenciaProgramada = 5,
  OrdenDeVenta = 6,
  ContraEntrega = 7
}